(() => {
  'use strict';
  const KEY = 'BosscoCanopyLanding';
  if (window[KEY]) { window[KEY].scan(); return; }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false, frame = 0, reveals, stories = [], parallax = [], active = false;
  let purchase, purchaseObserver, purchaseContainer, purchaseForm, syncing = false, cartErrorsBound = false;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const html = document.documentElement;
  const previewView = new URL(location.href).searchParams.get('view');
  function anchorTarget(link) {
    const href = link.getAttribute('href');
    if (!href) return null;
    try {
      const current = new URL(location.href);
      const url = new URL(href, current);
      if (url.origin !== current.origin || url.pathname !== current.pathname || url.search !== current.search || !url.hash) return null;
      return document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch { return null; }
  }
  function orderChapters() {
    document.querySelectorAll('[data-bc-chapter-rail]').forEach(rail => {
      const links = Array.from(rail.querySelectorAll('a'));
      const blockOrder = link => Number(link.dataset.bcChapterOrder) || 0;
      const ordered = [...links].sort((a, b) => {
        if (rail.dataset.bcFollowSectionOrder === 'false') return blockOrder(a) - blockOrder(b);
        const returnDifference = Number(a.dataset.bcChapterReturn === 'true') - Number(b.dataset.bcChapterReturn === 'true');
        if (returnDifference) return returnDifference;
        const targetA = anchorTarget(a), targetB = anchorTarget(b);
        if (targetA && targetB && targetA !== targetB) {
          const position = targetA.compareDocumentPosition(targetB);
          if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
          if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        }
        if (!!targetA !== !!targetB) return targetA ? -1 : 1;
        return blockOrder(a) - blockOrder(b);
      });
      ordered.forEach((link, index) => {
        // Avoid moving unchanged blocks: the editor and focused links retain their state.
        if (rail.children[index] !== link) rail.insertBefore(link, rail.children[index] || null);
        const number = link.querySelector('[data-bc-chapter-number]');
        const text = String(index + 1).padStart(2, '0');
        if (number && number.textContent !== text) number.textContent = text;
      });
    });
  }
  function scan() {
    const hero = document.querySelector('[data-bc-landing]');
    const motion = !reduce.matches && !paused && hero?.dataset.bcMotion !== 'false';
    active = !!hero || !!document.querySelector('[data-bc-story],.bc-build');
    html.classList.toggle('bc-landing-page', !!hero);
    html.classList.toggle('bc-motion-on', active && motion);
    reveals?.disconnect();
    if (active && motion && 'IntersectionObserver' in window) {
      reveals = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('bc-in-view'); reveals.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px -20px 0px' });
      document.querySelectorAll('[data-bc-reveal]').forEach(node => reveals.observe(node));
    } else document.querySelectorAll('[data-bc-reveal]').forEach(node => node.classList.add('bc-in-view'));
    stories = Array.from(document.querySelectorAll('[data-bc-story]'));
    stories.forEach(story => {
      const enhanced = motion && innerWidth >= 900 && story.dataset.bcMotion !== 'false';
      story.dataset.bcEnhanced = String(enhanced);
    });
    parallax = Array.from(document.querySelectorAll('[data-bc-parallax]'));
    document.querySelectorAll('[data-bc-motion-toggle]').forEach(button => {
      button.hidden = reduce.matches || hero?.dataset.bcMotion === 'false';
      button.setAttribute('aria-pressed', String(paused));
      button.innerHTML = paused ? 'Play motion <span aria-hidden="true">▷</span>' : 'Pause motion <span aria-hidden="true">Ⅱ</span>';
    });
    orderChapters();
    connectPurchase();
    tick();
  }
  function tick() {
    frame = 0;
    const motion = html.classList.contains('bc-motion-on');
    const hero = document.querySelector('[data-bc-landing]');
    if (hero) {
      const box = hero.getBoundingClientRect();
      hero.style.setProperty('--bc-hero-scale', motion ? (1.025 + clamp(-box.top / box.height, 0, 1) * .11).toFixed(3) : '1');
      const progress = document.querySelector('[data-bc-page-progress]');
      progress?.style.setProperty('--bc-page-progress', String(clamp(scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight), 0, 1)));
    }
    const proof = document.querySelector('.bc-fieldnote__photo');
    if (proof) {
      const box = proof.getBoundingClientRect();
      const travel = clamp((innerHeight / 2 - box.top - box.height / 2) / innerHeight, -1, 1);
      proof.style.setProperty('--bc-proof-drift', motion ? `${(travel * 22).toFixed(1)}px` : '0px');
      proof.style.setProperty('--bc-proof-scale', motion ? (1.05 + Math.abs(travel) * .035).toFixed(3) : '1.04');
    }
    document.querySelectorAll('.bc-landing-rail a').forEach(link => {
      const target = anchorTarget(link);
      if (!target) return;
      const box = target.getBoundingClientRect();
      link.style.setProperty('--bc-chapter-progress', String(clamp((innerHeight - box.top) / (innerHeight + box.height), 0, 1)));
    });
    for (const el of parallax) {
      if (!motion || innerWidth < 900) { el.style.removeProperty('--bc-parallax-y'); continue; }
      const box = el.parentElement.getBoundingClientRect();
      if (box.top > innerHeight || box.bottom < 0) continue;
      const amount = Math.max(-65, Math.min(65, (innerHeight / 2 - box.top - box.height / 2) * (Number(el.dataset.bcParallax) || .08)));
      el.style.setProperty('--bc-parallax-y', `${amount.toFixed(2)}px`);
    }
    for (const story of stories) {
      const heading = story.querySelector('.bc-canopy-story__title');
      if (heading) heading.style.setProperty('--bc-heading-drift', motion && innerWidth >= 900 ? `${clamp((innerHeight / 2 - heading.getBoundingClientRect().top) * .06, -28, 28).toFixed(1)}px` : '0px');
      if (story.dataset.bcEnhanced !== 'true') continue;
      const steps = Array.from(story.querySelectorAll('[data-bc-story-step]'));
      let closest = 0, distance = Infinity, containing = -1;
      steps.forEach((step, index) => {
        const box = step.getBoundingClientRect();
        if (box.top <= innerHeight / 2 && box.bottom >= innerHeight / 2) containing = index;
        const d = Math.abs(box.top + box.height / 2 - innerHeight / 2);
        if (d < distance) { distance = d; closest = index; }
      });
      if (containing >= 0) closest = containing;
      story.querySelectorAll('[data-bc-story-image]').forEach((image,index) => image.dataset.active = String(index === closest));
      steps.forEach((step,index) => step.dataset.active = String(index === closest));
    }
  }
  function revealPurchase() {
    const target = document.querySelector('#bc-canopy-buy') || purchaseContainer;
    target?.scrollIntoView({behavior:html.classList.contains('bc-motion-on')?'smooth':'auto',block:'start'});
  }
  function syncPurchase() {
    if (!purchase?.isConnected || !purchaseForm?.isConnected || syncing) return;
    const id = purchaseForm.querySelector('[name="id"]')?.value;
    const variant = purchase.variants.find(item => String(item.id) === String(id));
    const nativeButton = purchaseForm.querySelector('button[type="submit"]');
    const price = purchase.querySelector('[data-bc-price]');
    const compare = purchase.querySelector('[data-bc-compare]');
    const select = purchase.querySelector('[data-bc-variant]');
    const button = purchase.querySelector('[data-bc-add]');
    const status = purchase.querySelector('[data-bc-purchase-status]');
    if (variant) {
      price.innerHTML = variant.price;
      compare.innerHTML = variant.compare || '';
      compare.hidden = !variant.compare;
      if (select) select.value = String(variant.id);
    }
    const busy = nativeButton?.classList.contains('btn--in-progress');
    button.disabled = !variant?.available || !nativeButton || nativeButton.disabled || busy;
    button.setAttribute('aria-busy',String(!!busy));
    const text = busy ? 'Adding…' : !variant ? 'Choose your options' : !variant.available ? 'Sold out' : nativeButton?.textContent.trim() || 'Add to cart';
    purchase.querySelector('[data-bc-add-label]').textContent = text;
    if (!purchase.dataset.bcError) status.textContent = !variant ? 'Choose a configuration below.' : !variant.available ? 'Currently sold out. Check availability below.' : variant.backorder ? 'Available on backorder. Check delivery details below.' : 'Available to order';
  }
  function connectPurchase() {
    const panel = document.querySelector('[data-bc-landing] [data-bc-purchase]');
    const container = Array.from(document.querySelectorAll('[data-section-type="main-product"] .product-form')).find(node => node.dataset.productId === panel?.dataset.productId);
    const form = container?.querySelector('form.product-purchase-form');
    if (!panel || !container || !form) { purchaseObserver?.disconnect(); purchase = purchaseContainer = purchaseForm = null; return; }
    if (panel === purchase && container === purchaseContainer && form === purchaseForm) { syncPurchase(); return; }
    purchaseObserver?.disconnect();
    purchase = panel; purchaseContainer = container; purchaseForm = form;
    try { panel.variants = JSON.parse(panel.querySelector('[data-bc-variants]').textContent); } catch { return; }
    const ready = () => {
      if (!container.classList.contains('theme-init')) return;
      bindCartErrors();
      panel.querySelectorAll('[data-bc-purchase-controls]').forEach(node => node.hidden = false);
      panel.querySelector('[data-bc-purchase-fallback]').hidden = true;
      syncPurchase();
    };
    purchaseObserver = new MutationObserver(ready);
    purchaseObserver.observe(container,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class','value']});
    ready();
  }
  function bindCartErrors() {
    if (cartErrorsBound || !window.jQuery) return;
    cartErrorsBound = true;
    window.jQuery(document).on('ajaxError.bcCanopy', (_event, xhr, settings) => {
      if (!purchase?.isConnected || !/\/cart\/add/.test(settings.url || '')) return;
      let message = 'Unable to add this item. Check your selection and try again.';
      try { const response = JSON.parse(xhr.responseText); if (typeof response.description === 'string') message = response.description; } catch { /* Keep the useful fallback. */ }
      purchase.dataset.bcError = 'true';
      const errorStatus = purchase.querySelector('[data-bc-purchase-status]');
      errorStatus.textContent = message;
      errorStatus.hidden = false;
      syncPurchase();
    });
  }
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('[data-bc-variant]') && purchase?.contains(event.target)) {
      const variant = purchase?.variants.find(item => String(item.id) === event.target.value);
      if (!variant || !purchaseForm) return;
      delete purchase.dataset.bcError;
      const currentView = new URL(location.href).searchParams.get('view');
      syncing = true;
      // Use Mode's own selector API so visible options, app listeners and variant state agree.
      purchaseContainer.querySelectorAll('.option-selector').forEach((selector,index) => {
        const value = variant.options[index];
        const custom = selector.querySelector('.cc-select');
        if (custom) custom.dispatchEvent(new CustomEvent('selectOption',{detail:{value}}));
        else {
          const radio = Array.from(selector.querySelectorAll('input.js-option')).find(input => input.value === value);
          if (radio && !radio.checked) radio.click();
        }
      });
      purchaseContainer.querySelectorAll('[name="id"]').forEach(input => {
        input.value = String(variant.id);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      // Mode updates the variant URL; keep this alternate-template preview selected.
      if (currentView) { const url = new URL(location.href); url.searchParams.set('view',currentView); history.replaceState(history.state,'',url); }
      syncing = false;
      syncPurchase();
    } else if (purchaseContainer?.contains(event.target)) {
      delete purchase.dataset.bcError;
      queueMicrotask(() => {
        if (previewView) { const url = new URL(location.href); url.searchParams.set('view',previewView); history.replaceState(history.state,'',url); }
        syncPurchase();
      });
    }
  });
  function schedule() { if (active && !frame) frame = requestAnimationFrame(tick); }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const add = event.target.closest('[data-bc-add]');
    if (add && purchase?.contains(add)) {
      const nativeButton = purchaseForm?.querySelector('button[type="submit"]');
      if (!nativeButton || nativeButton.disabled) { syncPurchase(); return; }
      if (!purchaseForm.checkValidity()) { revealPurchase(); purchaseForm.reportValidity(); return; }
      delete purchase.dataset.bcError;
      nativeButton.click();
      syncPurchase();
      return;
    }
    const toggle = event.target.closest('[data-bc-motion-toggle]');
    if (toggle) { paused = !paused; scan(); return; }
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.bc-landing a[href^="#bc-canopy-"],.bc-landing-rail a,.bc-canopy-story a[href^="#bc-canopy-"]');
    if (!link) return;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const target = anchorTarget(link);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: html.classList.contains('bc-motion-on') ? 'smooth' : 'auto', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
    target.focus({ preventScroll: true });
  });
  addEventListener('scroll', schedule, { passive:true });
  addEventListener('resize', scan, { passive:true });
  reduce.addEventListener('change', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => setTimeout(scan,0));
  document.addEventListener('shopify:section:reorder', scan);
  document.addEventListener('bc:recommendations:loaded',scan);
  document.addEventListener('shopify:block:select', event => {
    const step = event.target.closest('[data-bc-story-step]');
    if (step) { step.scrollIntoView({block:'center',behavior:'auto'}); schedule(); }
  });
  window[KEY] = {scan};
  addEventListener('load',connectPurchase,{once:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
})();
